<div>
    <div *ngIf="category" class="card m-2">
        <div mat-dialog-title class="heading">Upload Document to {{category.name}}</div>
        <div class="ml-3" *ngIf="toggleUpload">
            <div class="mt-2" style="text-align: center;" *ngIf="category.parentname">
                Parent Category - {{category.parentname}}
            </div>
            <!-- <mat-divider></mat-divider> -->
            <form #initiateForm="ngForm">
                <!-- <mat-form-field appearance="standard">
                    <mat-label>Document Title</mat-label>
                    <input matInput name="documentTitle" [(ngModel)]="documentTitle" required>
                </mat-form-field> -->
                <div class="row" style="height:calc(100vh-93px);" *ngIf="fileToUpload">
                    <div class="col-6" style="overflow-y: auto;height:calc(100vh); width:100%; margin-bottom: 3px;">
                        <div mat-dialog-title style="padding-left: 15px; font-size:medium">Metadata</div>
                        <div class="input-group-sm mt-2 input-group col-12">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Document Title *</span>
                            </div>
                            <input class="form-control" name="document-title" [ngClass]="documentTitle?'':'empty-input'"
                                type="text" [(ngModel)]="documentTitle" required>
                        </div>

                        <div *ngFor="let key of category.meta_data_definition.properties; index as i;">
                            <div *ngIf="key.required==true">
                                <div *ngIf="key.data_type=='str' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}} *</span>
                                    </div>
                                    <input class="form-control" name="{{key.name}}"
                                        [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'"
                                        type="text" [(ngModel)]="category.meta_data_definition.properties[i].value"
                                        required>
                                </div>
                                <div *ngIf="key.data_type=='int' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}} *</span>
                                    </div>
                                    <input class="form-control" name="{{key.name}}"
                                        [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'"
                                        type="number" [(ngModel)]="category.meta_data_definition.properties[i].value"
                                        required>
                                </div>
                                <div *ngIf="key.data_type=='date' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}} *</span>
                                    </div>
                                    <div>
                                        <input class="form-control" name="{{key.name}}" 
                                        [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'" [matDatepicker]="datePicker"
                                        [ngModel]="category.meta_data_definition.properties[i].value  | date:'yyyy-MM-dd'" (ngModel)="category.meta_data_definition.properties[i].value = $any($event).target.valueAsDate"
                                        (dateChange)="updateList(category.meta_data_definition.properties, key, $event)" required>
                                    </div>
                                    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #datePicker></mat-datepicker>
                                    <mat-error *ngIf="key.isError">
                                        Date is invalid.
                                    </mat-error>
                                </div>
                                <div *ngIf="key.data_type=='str array' && !key.isHide" class="input-group-sm mt-2 input-group col-12"
                                    style="display: block;">
                                    <form class="card p-2" [formGroup]="valuesForm">
                                        <div formArrayName="{{key.name}}">
                                            <div class="row">
                                                <span class="form-group ml-3 form-label-105"
                                                    style="font-size: small;">{{key.name}} *</span>
                                                <div class="col mb-2">
                                                    <!-- <button mat-stroked-button > -->
                                                    <mat-icon class="float-right" title="Add Value"
                                                        (click)="addNewValue(key.name)">add</mat-icon>
                                                    <!-- </button> -->
                                                </div>
                                            </div>
                                            <div *ngFor="let item of getValues(valuesForm, key.name); let i=index"
                                                [formGroupName]="i">
                                                <div class="row">
                                                    <div class="col-11">
                                                        <div class="row">
                                                            <div class="input-group-sm mt-2 input-group col-12 mb-2">
                                                                <input class="form-control" type="text"
                                                                    [ngClass]="valuesForm.value[key.name][i].value!=''?'':'empty-input'"
                                                                    formControlName="value" required>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-1 p-0">
                                                        <mat-icon (click)="deleteForm(i,key.name)" style="position: relative;
                                                        top: 15%;" *ngIf="valuesArray(key.name).controls.length > 1">
                                                            delete
                                                        </mat-icon>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div *ngIf="key.data_type=='bool' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}} *</span>
                                    </div>
                                    <mat-slide-toggle class="ml-2" name="{{key.name}}"
                                        [(ngModel)]="category.meta_data_definition.properties[i].value">
                                    </mat-slide-toggle>
                                </div>
                                <div *ngIf="key.data_type=='object' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}} *</span>
                                    </div>
                                    <json-editor [options]="makeOptions()"
                                        [data]="category.meta_data_definition.properties[i].value"
                                        (change)="getData($event, i)"
                                        >
                                    </json-editor>
                                </div>
                                <div *ngIf="key.data_type=='options' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}} *</span>
                                    </div>
                                    <mat-select class="form-control" name="{{key.name}}"
                                        [ngClass]="category.meta_data_definition.properties[i].value?'':'empty-input'"
                                        type="list" [(ngModel)]="category.meta_data_definition.properties[i].value"
                                        required>
                                        <mat-option value="{{values}}" *ngFor="let values of key.values">{{values}}</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div *ngIf="key.required==false">
                                <div *ngIf="key.data_type=='str' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}} </span>
                                    </div>
                                    <input [disabled]="key.name=='Source'" class="form-control" name="{{key.name}}" type="text"
                                        [(ngModel)]="category.meta_data_definition.properties[i].value">
                                </div>
                                <div *ngIf="key.data_type=='int' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}} </span>
                                    </div>
                                    <input class="form-control" name="{{key.name}}" type="number"
                                        [(ngModel)]="category.meta_data_definition.properties[i].value">
                                </div>
                                <div *ngIf="key.data_type=='date' && !key.isHide" class="input-group-sm mt-2 input-group col-12">                                    
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}}</span>
                                    </div>
                                    <div>
                                        <input class="form-control" name="{{key.name}}" [matDatepicker]="datePicker"
                                        [ngModel]="category.meta_data_definition.properties[i].value  | date:'yyyy-MM-dd'" (ngModel)="category.meta_data_definition.properties[i].value = $any($event).target.valueAsDate"
                                        (dateChange)="updateList(category.meta_data_definition.properties, key, $event)">
                                    </div>
                                    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                                    <mat-datepicker #datePicker></mat-datepicker>
                                    <mat-error *ngIf="key.isError">
                                        Date is invalid.
                                    </mat-error>
                                </div>
                                <div *ngIf="key.data_type=='bool' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}}</span>
                                    </div>
                                    <mat-slide-toggle class="ml-2" name="{{key.name}}"
                                        [(ngModel)]="category.meta_data_definition.properties[i].value">
                                    </mat-slide-toggle>
                                </div>
                                <div *ngIf="key.data_type=='object' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}}</span>
                                    </div>
                                    <json-editor [options]="makeOptions()"
                                        [data]="category.meta_data_definition.properties[i].value"
                                        (change)="getData($event, i)"
                                        >
                                    </json-editor>
                                </div>
                                <div *ngIf="key.data_type=='options' && !key.isHide" class="input-group-sm mt-2 input-group col-12">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">{{key.name}}</span>
                                    </div>
                                    <mat-select class="form-control" name="{{key.name}}"
                                        type="list" [(ngModel)]="category.meta_data_definition.properties[i].value">
                                        <mat-option value="{{values}}" *ngFor="let values of key.values">{{values}}</mat-option>
                                    </mat-select>
                                </div>
                                <div *ngIf="key.data_type=='str array' && !key.isHide" class="input-group-sm mt-2 input-group col-12"
                                    style="display: block;">
                                    <form class="card p-2" [formGroup]="valuesForm">
                                        <div formArrayName="{{key.name}}">
                                            <div class="row">
                                                <span class="form-group ml-3 form-label-105"
                                                    style="font-size: small;">{{key.name}}</span>
                                                <div class="col mb-2">
                                                    <!-- <button mat-stroked-button > -->
                                                    <mat-icon class="float-right" title="Add Value"
                                                        (click)="addNewValue(key.name)">add</mat-icon>
                                                    <!-- </button> -->
                                                </div>
                                            </div>
                                            <div *ngFor="let item of getValues(valuesForm,key.name); let i=index"
                                                [formGroupName]="i">
                                                <div class="row">
                                                    <div class="col-11">
                                                        <div class="row">
                                                            <div class="input-group-sm mt-2 input-group col-12 mb-2">
                                                                <input class="form-control" type="text"
                                                                    formControlName="value">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-1 p-0">
                                                        <mat-icon (click)="deleteForm(i,key.name)" style="position: relative;
                                                        top: 15%;">delete
                                                        </mat-icon>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button class="mb-3 mr-2 closeButton" mat-raised-button (click)="onClose()">Discard</button>
                            <button *ngIf="valuesForm" class="mb-3 mr-2" mat-raised-button
                                [disabled]="!initiateForm.valid || !valuesForm.valid || !fileToUpload" type="submit"
                                (click)="uploadDocument()">Submit</button>
                            <button *ngIf="!valuesForm" class="mb-3 mr-2" mat-raised-button
                                [disabled]="!initiateForm.valid || !fileToUpload" type="submit"
                                (click)="uploadDocument()">Submit</button>&nbsp;
                        </div>
                    </div>
                    <div class="col-6">
                        <div mat-dialog-title style="font-size: medium;">Preview</div>
                        <app-file-preview [filePath]="filePath"></app-file-preview>
                    </div>
                </div>
            </form>
        </div>

        <div *ngIf="uploadMessage">
            <div class="mt-2" style="text-align: center;">File Upload has been completed successfully.</div>
            <div *ngIf="isWorkflow" class="mt-2" style="text-align: center;">Workflow {{workflowID}} has been initiated.
            </div>
            <button style="margin: 1em;" mat-raised-button (click)="onClose()">Close</button>
        </div>
        <div *ngIf="isError">
            <div class="mt-2" style="text-align: center; color: red;">{{errorMessage}}</div>
        </div>

    </div>
</div>